import { SVGProps } from 'react';
import { ReactComponent } from 'icons/polygon-menu-active.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const PolygonMenuIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-polygon-menu" {...props} />;
};
